module.exports = __webpack_public_path__ + "img/insert-03-gauche.20742e02.svg";